import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { useEffect, type JSX } from 'react';
import { useSegmentClientContext } from './client-provider';
import type { AnalyticsUser, Properties } from '../types';
interface Props<UserTraits> {
  children: React.ReactNode;
  user?: AnalyticsUser<UserTraits>;
}

/**
 * Use the Segment provider to add the initial identify and page calls.
 */
export function UserTracker(props) {
  const $ = _c(4);
  const {
    children,
    user
  } = props;
  const {
    client: analytics
  } = useSegmentClientContext();
  let t0;
  let t1;
  if ($[0] !== analytics || $[1] !== user) {
    t0 = () => {
      if (user) {
        analytics.identify(user);
      }
    };
    t1 = [analytics, user];
    $[0] = analytics;
    $[1] = user;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return children as JSX.Element;
}